import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { ChevronDown } from 'react-feather';

import { StyledTitleGroup, StyledBodyToggle } from './SectionHeaderTitle.styles';

const SectionHeaderTitle = ({ intl, isActive = false, setIsActive, titleId }) => (
  <StyledTitleGroup>
    <FormattedMessage id={titleId} />
    <StyledBodyToggle
      data-cy="section-header-title-toggle"
      data-testid="section-header-title-toggle"
      type="button"
      onClick={() => setIsActive(!isActive)}
      isActive={isActive}
      title={isActive ? intl.formatMessage({ id: 'journeySummary.seeLess' }) : intl.formatMessage({ id: 'journeySummary.seeMore' })}
    >
      <ChevronDown />
    </StyledBodyToggle>
  </StyledTitleGroup>
);

SectionHeaderTitle.propTypes = {
  intl: intlShape.isRequired,
  isActive: PropTypes.bool,
  setIsActive: PropTypes.func,
  titleId: PropTypes.string.isRequired
};

export default injectIntl(SectionHeaderTitle);
